import React from 'react';
import { Redirect } from 'react-router-dom';
import { RotateLeft } from '@material-ui/icons';
import { Autocomplete } from '@material-ui/lab';
import { IconButton, LinearProgress } from '@material-ui/core';

import { BackButton, TextField } from '../../components/AtomComponents';
import ResultsTable from '../../components/PxwProcessDevices/ResultsTable';
import PxwSelectionForm from '../../components/PxwProcessDevices/PxwSelectionForm';

import { usePxwProcessDevices } from './usePxwProcessDevices';

import './PxwProcessDevices.scss';

const PxwProcessDevices = () => {
  const {
    userRoles,
    isLoading,
    tenantList,
    selectedTenant,
    generatedResult,
    handleTenantChange,
    handleReset,
    handleSynthesize,
    onResultInvalidated,
  } = usePxwProcessDevices();

  if (!userRoles['PXW_SANDBOX']) return <Redirect to="/dashboard" />;

  return (
    <div className="grid-y pxw-process-devices">
      <div className="pxw-process-devices__header">
        <BackButton />
        <h3 className="margin-0">PXW Process Devices</h3>
        <div className="pxw-process-devices__tenant-select">
          <Autocomplete
            options={tenantList || []}
            value={selectedTenant}
            getOptionLabel={(o) => o}
            onChange={handleTenantChange}
            renderInput={(params) => (
              <TextField {...params} label="Select Tenant" variant="outlined" />
            )}
          />
        </div>
        {selectedTenant && (
          <IconButton size="small" title="Reset all selections" onClick={handleReset}>
            <RotateLeft />
          </IconButton>
        )}
      </div>

      {!tenantList ? (
        <div className="cell margin-top-1 margin-bottom-2 small-12 medium-7">
          <LinearProgress />
        </div>
      ) : (
        <>
          <PxwSelectionForm
            selectedTenant={selectedTenant}
            isLoading={isLoading}
            onSynthesize={handleSynthesize}
            onResultInvalidated={onResultInvalidated}
          />
          {isLoading ? (
            <div className="cell margin-top-1 margin-bottom-2 small-12">
              <LinearProgress />
            </div>
          ) : generatedResult ? (
            <ResultsTable
              groupedDevices={generatedResult.groupedDevices}
              selectedItem={generatedResult.item}
            />
          ) : null}
        </>
      )}
    </div>
  );
};

export default PxwProcessDevices;
